export default __webpack_public_path__ + "static/media/state-2.1332ea51.svg";